import { AccountManagerColumn, CommonAccountManagerColumnId } from '@frontends/feature-charting-library/broker-api';
import { OrderStatusFilter, StandardFormatterName } from '@frontends/feature-charting-library/charting_library';
import tradingViewClientI18n from '../../../i18n';

export const getColumns = (): {
  ordersPageColumns: AccountManagerColumn[];
  positionsPageColumns: AccountManagerColumn[];
} => {
  return {
    ordersPageColumns: [
      {
        label: tradingViewClientI18n.t('symbol'),
        formatter: StandardFormatterName.Symbol,
        id: CommonAccountManagerColumnId.Symbol,
        dataFields: ['symbol', 'symbol', 'message'],
      },
      {
        label: tradingViewClientI18n.t('side'),
        id: 'side',
        dataFields: ['side'],
        formatter: StandardFormatterName.Side,
      },
      {
        label: tradingViewClientI18n.t('orderType'),
        id: 'type',
        dataFields: ['type', 'parentId', 'stopType'],
        formatter: StandardFormatterName.Type,
      },
      {
        label: tradingViewClientI18n.t('volume'),
        id: 'qty',
        dataFields: ['qty'],
        formatter: StandardFormatterName.FormatQuantity,
        showZeroValues: true,
      },
      {
        label: tradingViewClientI18n.t('price'),
        id: 'avgPrice',
        dataFields: ['avgPrice'],
        formatter: StandardFormatterName.FormatPrice,
      },
      {
        label: tradingViewClientI18n.t('stopLoss'),
        id: 'stopLoss',
        dataFields: ['stopLoss'],
        formatter: StandardFormatterName.FormatPrice,
      },
      {
        label: tradingViewClientI18n.t('takeProfit'),
        id: 'takeProfit',
        dataFields: ['takeProfit'],
        formatter: StandardFormatterName.FormatPrice,
      },
      {
        label: tradingViewClientI18n.t('lastPrice'),
        id: 'last',
        dataFields: ['last'],
        formatter: StandardFormatterName.FormatPriceForexSup,
        highlightDiff: true,
      },
      {
        label: tradingViewClientI18n.t('status'),
        id: 'status',
        dataFields: ['status'],
        formatter: StandardFormatterName.Status,
        supportedStatusFilters: [OrderStatusFilter.All],
      },
      {
        label: tradingViewClientI18n.t('time'),
        id: 'time',
        dataFields: ['time'],
        formatter: StandardFormatterName.LocalDate,
      },
      {
        label: tradingViewClientI18n.t('ticket'),
        id: 'id',
        dataFields: ['id'],
        formatter: (value: number) => value,
        sortable: true,
      },
    ],

    positionsPageColumns: [
      {
        label: tradingViewClientI18n.t('symbol'),
        formatter: StandardFormatterName.Symbol,
        id: CommonAccountManagerColumnId.Symbol,
        dataFields: ['symbol', 'symbol', 'message'],
      },
      {
        label: tradingViewClientI18n.t('side'),
        id: 'side',
        dataFields: ['side'],
        formatter: StandardFormatterName.Side,
      },
      {
        label: tradingViewClientI18n.t('volume'),
        id: 'qty',
        dataFields: ['qty'],
        formatter: StandardFormatterName.FormatQuantity,
      },
      {
        label: tradingViewClientI18n.t('price'),
        id: 'avgPrice',
        dataFields: ['avgPrice'],
        formatter: StandardFormatterName.FormatPrice,
      },
      {
        label: tradingViewClientI18n.t('stopLoss'),
        id: 'stopLoss',
        dataFields: ['stopLoss'],
        formatter: StandardFormatterName.FormatPrice,
      },
      {
        label: tradingViewClientI18n.t('takeProfit'),
        id: 'takeProfit',
        dataFields: ['takeProfit'],
        formatter: StandardFormatterName.FormatPrice,
      },
      {
        label: tradingViewClientI18n.t('lastPrice'),
        id: 'last',
        dataFields: ['last'],
        formatter: StandardFormatterName.FormatPriceForexSup,
        highlightDiff: true,
      },
      {
        label: tradingViewClientI18n.t('unrealizedP&L'),
        id: 'pl',
        dataFields: ['pl', 'currency'],
        formatter: StandardFormatterName.ProfitInInstrumentCurrency,
        showZeroValues: true,
      },
      {
        label: tradingViewClientI18n.t('time'),
        id: 'time',
        dataFields: ['time'],
        formatter: StandardFormatterName.LocalDate,
      },
      {
        label: tradingViewClientI18n.t('ticket'),
        id: 'id',
        dataFields: ['id'],
        formatter: (value: number) => value,
        sortable: true,
      },
    ],
  };
};
